import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { mq } from '../../styles/vars/media-queries.style'
import TransitionLink from 'gatsby-plugin-transition-link'
import { easings } from '../../styles/vars/easings.style'

export const PageTransitionLinkInner = styled.span`
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  will-change: transform;

  &:nth-child(1) {
    transition: transform ${easings.out.quart}, opacity ${easings.out.quart};
    transition-duration: 0.4s;
    transition-delay: 0.25s;
  }
  &:nth-child(2) {
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transform: translateY(100%);
    transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
    transition-duration: 0.4s;
  }
`

// Will be combined in to a shared style with Button component later
export const PageTransitionLinkMain = styled(TransitionLink)`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  position: relative;

  ${mq.desk} {
    &:hover {
      ${PageTransitionLinkInner} {
        &:nth-child(1) {
          opacity: 0;
          transform: translateY(-101%);
          transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
          transition-duration: 0.4s;
        }
        &:nth-child(2) {
          opacity: 1;
          transform: translateY(0);
          transition: transform ${easings.out.quart},
            opacity ${easings.out.quart};
          transition-duration: 0.4s;
          transition-delay: 0.25s;
        }
      }
    }
  }

  ${props =>
    props.theme === 'underline' &&
    `
      border-bottom: 0.1rem solid ${colors.dark};
      padding-bottom: 0.3rem;
    `}

  ${props =>
    props.theme === 'filled' &&
    `
      background-color: ${colors.dark};
      color: ${colors.light};
    `}

  ${props =>
    (props.theme === 'filled' || props.theme === 'outlined') &&
    `
      border: 0.1rem solid ${colors.dark};
      ${clamp(
        'border-radius',
        25,
        25,
        breakpoints.mobile,
        breakpoints.contained
      )}
      line-height: 1;
      ${clamp(
        'padding-bottom',
        10,
        15,
        breakpoints.mobile,
        breakpoints.contained
      )}
      ${clamp(
        'padding-left',
        18,
        32,
        breakpoints.mobile,
        breakpoints.contained
      )}
      ${clamp(
        'padding-right',
        18,
        32,
        breakpoints.mobile,
        breakpoints.contained
      )}
      ${clamp('padding-top', 8, 14, breakpoints.mobile, breakpoints.contained)}
    `}

  border-color: ${props => props.color};
  background-color: ${props =>
    props.color && props.theme === 'filled' && props.color};
`
